"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Chin_1 = require("./Chin");
var Full_1 = require("./Full");
var FullMajestic_1 = require("./FullMajestic");
var FullMedium_1 = require("./FullMedium");
var Goatee_1 = require("./Goatee");
var GoateeCircle_1 = require("./GoateeCircle");
var Dali_1 = require("./Dali");
var Handlebars_1 = require("./Handlebars");
var Imperial_1 = require("./Imperial");
var Painters_1 = require("./Painters");
var PaintersFilled_1 = require("./PaintersFilled");
var Swashbuckler_1 = require("./Swashbuckler");
var MoustacheThin_1 = require("./MoustacheThin");
var Yosemite_1 = require("./Yosemite");
var GrayFull_1 = require("./GrayFull");
var MajesticHandlebars_1 = require("./MajesticHandlebars");
var None_1 = require("./None");
exports.FacialHair = {
    None: None_1.None,
    Chin: Chin_1.Chin,
    Full: Full_1.Full,
    FullMajestic: FullMajestic_1.FullMajestic,
    FullMedium: FullMedium_1.FullMedium,
    Goatee: Goatee_1.Goatee,
    GoateeCircle: GoateeCircle_1.GoateeCircle,
    Dali: Dali_1.Dali,
    Handlebars: Handlebars_1.Handlebars,
    Imperial: Imperial_1.Imperial,
    Painters: Painters_1.Painters,
    PaintersFilled: PaintersFilled_1.PaintersFilled,
    Swashbuckler: Swashbuckler_1.Swashbuckler,
    MoustacheThin: MoustacheThin_1.MoustacheThin,
    Yosemite: Yosemite_1.Yosemite,
    GrayFull: GrayFull_1.GrayFull,
    MajesticHandlebars: MajesticHandlebars_1.MajesticHandlebars
};
//# sourceMappingURL=z_options.js.map